import script from "./AddProfilerSessionModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AddProfilerSessionModal.vue?vue&type=script&setup=true&lang=js"

import "./AddProfilerSessionModal.vue?vue&type=style&index=0&id=039756f8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-039756f8"]])

export default __exports__